import React from 'react';
import GenericInternalTransfer from '../GenericInternalTransfer';

const ECOMInternalTransfer = () => (
  <GenericInternalTransfer
    sectionName="ECOM Section"
    sectionKey="ECOM"
    backRoute="/sections/ecom"
  />
);

export default ECOMInternalTransfer;
